import { forwardRef } from "react";
import { Button, type ButtonProps } from "./Button";

export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ children, variant = "ghost", ...props }, ref) => {
        return (
            <Button ref={ref} variant={variant} {...props}>
                {children}
            </Button>
        );
    },
);
